import { Flex, type FlexProps } from "@similarweb/ui-components/foundations";

import { WebsiteTooltip } from "app/components/React/Tooltip/WebsiteTooltip/WebsiteTooltip";

import { IconWrapper, WebsiteName } from "./StyledComponents";

interface IBannerItemProps extends Pick<FlexProps, "data-automation"> {
    domain: string;
    imgSrc: string;
}

export const BannerItem = ({ domain, imgSrc, ...props }: IBannerItemProps) => (
    <WebsiteTooltip
        domain={domain}
        placement="bottom-left"
        debounce={500}
    >
        <Flex {...props}>
            <IconWrapper>
                <img
                    src={imgSrc}
                    alt={domain}
                />
            </IconWrapper>
            <WebsiteName>{domain}</WebsiteName>
        </Flex>
    </WebsiteTooltip>
);
